import React from 'react'
import Link from 'next/link'

interface TagsProps {
    tags: any
}

export default function Tags({ tags }: TagsProps) {
    return (
       <div className='flex justify-start text-base leading-5 pb-5 flex-wrap gap-6'>
        {
            tags.map((tag: any) => {
                return (
                    <Link className='font-[Judge] inline-block uppercase text-black bg-hot-yellow my-2 py-2 px-2' prefetch={false} key={tag.sys.id} href={'/tag/' + tag.sys.id}>
                        #{tag.name}
                    </Link>
                )
            })
        }
    </div>
    )
}


